'use client'

import { motion } from 'framer-motion'
import Image from 'next/image'
import clsx from 'clsx'

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
}

export interface PhilosophySectionProps {
  title: string
  paragraph: string
  logoSrc?: string
  logoAlt?: string
  logoOpacity?: number
  className?: string
}

const PhilosophySection: React.FC<PhilosophySectionProps> = ({
  title,
  paragraph,
  logoSrc = '/reach-logo.png',
  logoAlt = 'ReACH Psychiatry Logo',
  logoOpacity = 1,
  className = '',
}) => (
  <section
    className={clsx('py-12 sm:py-16 lg:py-20 px-4 bg-gray-50', className)}
  >
    <div className="max-w-7xl mx-auto">
      <motion.div
        className="max-w-3xl mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={fadeIn}
      >
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif text-gray-900 mb-6 sm:mb-8">
          {title}
        </h2>

        {/* Logo */}
        <div className="relative mb-8 sm:mb-12">
          <Image
            src={logoSrc}
            alt={logoAlt}
            width={120}
            height={48}
            className="mx-auto"
            style={{ opacity: logoOpacity }}
            priority
          />
        </div>

        <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
          {paragraph}
        </p>
      </motion.div>
    </div>
  </section>
)

export default PhilosophySection
